import { useEffect, useState } from 'react';
import { Column, Tab, TabList, TabPanel, Tabs, Text } from '~/commonComponents';
import { PendingReviewShiftsTab, TodayShiftsTab } from './components';
import { useActiveShifts } from './hooks';
import { Colors } from '~/themes/colors';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { EnforceOfficeDashboardV2 } from '~/constants/ff.posthog';

export const ActiveShift = () => {
  const { activeTab: defaultActiveTab, counters } = useActiveShifts();

  const [activeTab, setActiveTab] = useState<number>(defaultActiveTab);

  const useOfficeDashboardV2 = useFeatureFlag(EnforceOfficeDashboardV2);

  useEffect(() => {
    setActiveTab(defaultActiveTab);
  }, [defaultActiveTab]);

  if (counters.todays === 0 && counters.reviews === 0) {
    return null;
  }

  return (
    <Column
      className="dashboard-active-shifts"
      paddingBlock={24}
      paddingInline={48}
      data-cy="active-shifts-container"
    >
      {!useOfficeDashboardV2 && (
        <Text
          bold
          fontSize={24}
          textAlign="center"
          marginInline="auto"
          data-cy="active-shifts-title"
        >
          Active Shifts
        </Text>
      )}

      <Tabs
        initialTab={activeTab}
        style={{ alignItems: 'start', marginTop: 24, width: '100%' }}
        onChangeTab={setActiveTab}
        data-cy="active-shifts-tabs"
      >
        <TabList data-cy="active-shifts-tab-list">
          <Tab title="Today's Professionals" totalCount={counters.todays} dataCy="todays-shifts-tab" />
          <Tab
            title="Pending Review"
            totalCount={counters.reviews}
            totalCountStyle={
              counters.reviews > 0
                ? {
                    backgroundColor: activeTab === 1 ? Colors.error_500 : Colors.error_100,
                  }
                : {}
            }
            totalCountTextStyle={
              counters.reviews > 0
                ? {
                    color: activeTab === 1 ? Colors.white : Colors.error_500,
                  }
                : {}
            }
            dataCy="pending-review-tab"
          />
        </TabList>
        <TabPanel data-cy="active-shifts-tab-panel">
          <TodayShiftsTab />
          <PendingReviewShiftsTab />
        </TabPanel>
      </Tabs>
    </Column>
  );
};
